var _style, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _path, _polygon9, _polygon0, _polygon1, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _polygon15, _polygon16, _polygon17, _polygon18, _polygon19, _polygon20, _polygon21, _polygon22, _polygon23, _polygon24, _polygon25, _polygon26, _polygon27, _polygon28, _polygon29, _polygon30, _polygon31, _polygon32, _polygon33;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFuturama(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 400 200",
    style: {
      enableBackground: "new 0 0 400 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#C9AD2E;}\n\t.st1{fill:#D1B935;}\n\t.st2{fill:url(#SVGID_1_);}\n\t.st3{fill:url(#SVGID_00000031922978491533180100000013221673384971974580_);}\n\t.st4{fill:url(#SVGID_00000099623233365620669620000003504000661170900912_);}\n\t.st5{fill:url(#SVGID_00000068669131660768274920000008444048930175495587_);}\n\t.st6{fill:url(#SVGID_00000127039625435974379860000002891820341217651332_);}\n\t.st7{fill:url(#SVGID_00000103224392214764472230000011549413879305982338_);}\n\t.st8{fill:url(#SVGID_00000168835614779366793870000004895933068968410810_);}\n\t.st9{fill:url(#SVGID_00000145035427543565533640000003154544175601671584_);}\n\t.st10{fill:url(#SVGID_00000096745071674018232360000001080970606800605572_);}\n\t.st11{fill:url(#SVGID_00000011016200431009517160000016542912587176678576_);}\n\t.st12{fill:url(#SVGID_00000138550165980669752030000009566114359480782235_);}\n\t.st13{fill:url(#SVGID_00000145763671011360434340000001647098893450741134_);}\n\t.st14{fill:url(#SVGID_00000036932395031939966740000002338990692089667519_);}\n\t.st15{fill:url(#SVGID_00000110471877344185077910000014007235513199274134_);}\n\t.st16{fill:url(#SVGID_00000088819875206665636050000004034830791958545336_);}\n\t.st17{fill:url(#SVGID_00000142886530676144806200000005797134446013304734_);}\n\t.st18{fill:url(#SVGID_00000030471630664288549380000008792180773081778579_);}\n\t.st19{fill:url(#SVGID_00000085235798338649527690000002267622000465914805_);}\n\t.st20{fill:url(#SVGID_00000124853784494035359280000002457751536191768226_);}\n\t.st21{fill:#CCAF2F;}\n\t.st22{fill:url(#SVGID_00000016753790284978718050000013455331358107735469_);}\n\t.st23{fill:url(#SVGID_00000116942890027258295370000011575358169184268213_);}\n\t.st24{fill:url(#SVGID_00000084487697294843194740000015600468541662519714_);}\n\t.st25{fill:url(#SVGID_00000147901296117153341340000008089271708265356963_);}\n\t.st26{fill:url(#SVGID_00000127021339198354722000000001467936273997194673_);}\n\t.st27{fill:url(#SVGID_00000158000840514241028630000010647557267912501382_);}\n\t.st28{fill:url(#SVGID_00000076590022742708915370000015983955716047354773_);}\n\t.st29{fill:url(#SVGID_00000170960555206056402810000017721401253540688265_);}\n\t.st30{fill:url(#SVGID_00000065795735807518545380000006691762510956140167_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "F"
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "58.3,93.5 62.8,96.1 69.7,107.5 65.1,104.9  "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "56.4,111 65.1,104.9 69.7,107.5 61,113.6  "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "56.4,111 61,113.6 62.5,116.2 60.4,117.6  "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "76.1,128.5 71.9,126.4 64.7,114.6 69.3,117.2  "
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "76.1,128.5 71.8,131.6 67.5,129.4 71.9,126.4  "
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "77.2,140.8 72.9,138.7 67.5,129.4 71.8,131.6  "
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "77.2,140.8 65.6,148.9 61.4,146.8 72.9,138.7  "
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "58.2,141.3 56.5,142.5 51.7,140.5 56,137.5  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 38.4893,
    y1: 81.8347,
    x2: 72.9389,
    y2: 81.8347,
    gradientTransform: "matrix(1 0 0 -1 0 202)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F5ED60"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F7EF74"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M61.4,146.8l-5.4-9.3l-4.2,3l-6.9-11.9l4.2-3l-10.6-18.2l19.8-13.9l6.9,11.4l-8.7,6.1l4,6.6l4.4-3.1l7.1,11.8 l-4.4,3.1l5.5,9.3L61.4,146.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000111893214733498537310000010420217690580078214_",
    gradientUnits: "userSpaceOnUse",
    x1: 46.6111,
    y1: 99.7199,
    x2: 68.6982,
    y2: 61.464,
    gradientTransform: "matrix(1 0 0 -1 0 202)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#68120C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D83020"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000111893214733498537310000010420217690580078214_)"
    },
    points: "40.7,107.9 57.8,95.8  62.9,104.4 54.2,110.6 59.9,120 64.3,116.9 69.7,125.9 65.3,129 70.8,138.2 61.9,144.5 56.5,135.2 52.2,138.1 47,129.1  51.2,126.1  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000056411285861373198780000008777839360131013793_",
    gradientUnits: "userSpaceOnUse",
    x1: 46.6999,
    y1: 99.5633,
    x2: 68.6068,
    y2: 61.6194,
    gradientTransform: "matrix(1 0 0 -1 0 202)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#771915"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EE3524"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000056411285861373198780000008777839360131013793_)"
    },
    points: "56.5,134.9 52.3,137.9  47.2,129.1 51.4,126.1 40.9,107.9 57.7,96.1 62.7,104.4 54,110.5 59.8,120.2 64.2,117.2 69.4,125.8 65.1,128.9 70.5,138.2  61.9,144.2  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "U_1_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000145760894167713808140000005993426273225922706_",
    gradientUnits: "userSpaceOnUse",
    x1: 83.7714,
    y1: 103.363,
    x2: 116.2083,
    y2: 103.363,
    gradientTransform: "matrix(1 0 0 -1 0 202)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C9AD2E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#D1B935"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C9AD2E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000145760894167713808140000005993426273225922706_)"
    },
    d: "M97.7,126c-9.4,0-13.6-9.5-14-10.5 c0,0,12.6,5.4,21.9-2c6.9-5.5-10.2-33.9-10.2-33.9l2.8-8.5l3.1,3.3l12.5,24.2c0.4,0.9,7.9,15.6-6.8,24.3 C103.9,125.1,100.7,126,97.7,126z"
  }), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "79.4,81.9 83.3,84.5 96.1,110 92,109.1 91.8,106.7  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000130628395716767235800000002939813368517864067_",
    gradientUnits: "userSpaceOnUse",
    x1: 82.0122,
    y1: 121.8452,
    x2: 105.0145,
    y2: 82.004,
    gradientTransform: "matrix(1 0 0 -1 0 202)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F5ED60"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F7EF74"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000130628395716767235800000002939813368517864067_)"
    },
    d: "M94,123.8c-9.6,0-13.9-9.5-14.3-10.5 L67.4,88.6l12-6.7l12.5,25c0,0.1,0.9,2.2,2.9,2.2c0.8,0,1.7-0.3,2.7-0.9c1-0.6,1.6-1.3,1.8-2.2c0.3-1.5-0.7-3-0.7-3.1l-0.1-0.2 L86.1,78.1l12.2-6.9l12.4,24.9c0.5,0.9,7.8,15.9-7.2,24.7C100.3,122.8,97.1,123.8,94,123.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000012433480520507282770000017675791379144459400_",
    gradientUnits: "userSpaceOnUse",
    x1: 82.7993,
    y1: 120.3858,
    x2: 104.1538,
    y2: 83.3987,
    gradientTransform: "matrix(1 0 0 -1 0 202)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#68120C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EE3524"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C73023"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000012433480520507282770000017675791379144459400_)"
    },
    d: "M69.6,89.2l9.1-5.1l11.7,23.4 c0,0,2.1,5.6,7.9,2.2c4.9-2.9,1.7-7.5,1.7-7.5L88.3,78.7l9.4-5.2l11.7,23.4c0,0,7.6,14.2-6.5,22.5c-15.2,8.9-21.6-6.8-21.6-6.8 L69.6,89.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000130630690281494176500000011258173413396335294_",
    gradientUnits: "userSpaceOnUse",
    x1: 82.8814,
    y1: 120.2406,
    x2: 104.0702,
    y2: 83.5405,
    gradientTransform: "matrix(1 0 0 -1 0 202)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#771915"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EE3524"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DB3628"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000130630690281494176500000011258173413396335294_)"
    },
    d: "M94,122c-8.7,0-12.6-9.3-12.6-9.4 L69.8,89.3l8.8-4.9l11.6,23.2c0,0,1.3,3.4,4.6,3.4c1.1,0,2.3-0.4,3.6-1.1c1.5-0.9,2.4-2,2.7-3.3c0.5-2.3-0.9-4.4-1-4.4L88.5,78.8 l9.1-5.1l11.6,23.2c0,0,1.9,3.6,2,8.1c0.1,4.1-1.3,10-8.5,14.2C99.7,121,96.7,122,94,122z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "T"
  }, _polygon0 || (_polygon0 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "140.1,55.4 142.2,59.2 146.1,72 144.1,68.3  "
  })), _polygon1 || (_polygon1 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "133.7,71.8 144.1,68.3 146.1,72 136,75.4  "
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "143.3,102.9 145.3,105.7 136,75.4 133.7,71.8  "
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "130,107.4 132,110.2 145.3,105.7 143.3,102.9  "
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "110.2,79.7 113.2,83.1 121.7,80.2 120.4,76.2  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000090268248263191681050000010304570603924736701_",
    gradientUnits: "userSpaceOnUse",
    x1: 122.9207,
    y1: 140.908,
    x2: 137.9415,
    y2: 97.2842,
    gradientTransform: "matrix(1 0 0 -1 0 202)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F5ED60"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F7EF74"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000090268248263191681050000010304570603924736701_)"
    },
    d: "M130,107.4l-9.5-31.1l-10.2,3.4 l-3.9-12.8l33.9-11.4l3.9,12.8l-10.3,3.5l9.5,31.1L130,107.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000059276979428350361360000015638516576839164567_",
    gradientUnits: "userSpaceOnUse",
    x1: 123.4577,
    y1: 139.3042,
    x2: 137.4045,
    y2: 98.7998,
    gradientTransform: "matrix(1 0 0 -1 0 202)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#68120C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D83020"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000059276979428350361360000015638516576839164567_)"
    },
    points: "108.3,67.9 139,57.6 142,67.3  131.7,70.8 141.2,101.9 131,105.3 121.5,74.2 111.3,77.6  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000075882388045161497300000008921500911713923506_",
    gradientUnits: "userSpaceOnUse",
    x1: 123.5117,
    y1: 139.1913,
    x2: 137.3505,
    y2: 99.0007,
    gradientTransform: "matrix(1 0 0 -1 0 202)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#771915"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EE3524"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000075882388045161497300000008921500911713923506_)"
    },
    points: "121.6,73.9 111.4,77.4  108.5,68 138.9,57.7 141.8,67.1 131.5,70.6 141,101.7 131.2,105.1  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "U"
  }, _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "162.5,52.8 163.7,55.7 166.8,85 165.3,82.3 165.5,80.6  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000127722640319567950590000004512028490590386622_",
    gradientUnits: "userSpaceOnUse",
    x1: 153.8775,
    y1: 112.4832,
    x2: 187.8023,
    y2: 112.4832,
    gradientTransform: "matrix(1 0 0 -1 0 202)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C9AD2E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#D1B935"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C9AD2E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000127722640319567950590000004512028490590386622_)"
    },
    d: "M169.5,101.2c-10.2,0-14.1-7-15.6-11.7 c-0.7-2.1,10.8,6.7,18.6,5.4c10.8-1.8,14.9-17.1,14.9-17.1l0.3,2.9c0.1,0.6,1,8.9-4,14.8C180.5,99.3,175.7,101.2,169.5,101.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000183934345956244359610000000565739778079999912_",
    gradientUnits: "userSpaceOnUse",
    x1: 166.298,
    y1: 149.844,
    x2: 171.9371,
    y2: 103.9171,
    gradientTransform: "matrix(1 0 0 -1 0 202)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F5ED60"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F7EF74"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000183934345956244359610000000565739778079999912_)"
    },
    d: "M168.6,98.3c-15.4,0-16.8-14.8-16.9-15.9 l-3-27.8l13.8-1.8l3,27.9c0.1,0.5,0.7,3.6,3.8,3.6c1.5,0,2.6-0.4,3.3-1.1c1.1-1.3,0.7-3.4,0.7-3.4l0-0.1l-3-27.8l14.1-1.8l3,27.9 c0.1,0.6,1,8.9-4.2,14.8C179.9,96.4,175,98.3,168.6,98.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000177473953738448500170000017830175283835948679_",
    gradientUnits: "userSpaceOnUse",
    x1: 166.4831,
    y1: 148.2064,
    x2: 171.7216,
    y2: 105.5421,
    gradientTransform: "matrix(1 0 0 -1 0 202)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#68120C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D83020"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000177473953738448500170000017830175283835948679_)"
    },
    d: "M150.5,56l10.6-1.4l2.8,26.3 c0,0,0.8,5,5.4,5c6.8,0,5.5-6.5,5.5-6.5L172,53.2l10.9-1.4l2.8,26.2c0,0,2.5,18.6-17.2,18.6c-14.5,0-15.3-14.4-15.3-14.4L150.5,56 z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000136371114591612962200000016240022217235418301_",
    gradientUnits: "userSpaceOnUse",
    x1: 166.5526,
    y1: 148.0414,
    x2: 171.7508,
    y2: 105.706,
    gradientTransform: "matrix(1 0 0 -1 0 202)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#771915"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EE3524"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000136371114591612962200000016240022217235418301_)"
    },
    d: "M168.6,96.5 c-14.2,0-15.1-14.1-15.1-14.2l-2.8-26.1l10.3-1.3l2.8,26.1c0,0.1,0.8,5.2,5.6,5.2c2.1,0,3.7-0.6,4.7-1.8c1.6-2,1.1-4.7,1-4.8 l-2.8-26.1l10.6-1.4l2.8,26.1c0,0.1,1,8-3.7,13.4C179,94.8,174.5,96.5,168.6,96.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "R"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000045590831411948076850000011901488240713408907_",
    gradientUnits: "userSpaceOnUse",
    x1: 227.56,
    y1: 134.5061,
    x2: 227.56,
    y2: 115.1138,
    gradientTransform: "matrix(1 0 0 -1 0 202)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C9AD2E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D1B935"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000045590831411948076850000011901488240713408907_)"
    },
    d: "M233.2,67.5c0,0,0.5,6.4-3.1,12.3 c-2.9,4.7-7.2,7.1-7.2,7.1l-1.1-2.5c0,0,6-4.3,7.7-7.5C231.3,73.7,233.2,67.5,233.2,67.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000127742134137208976560000007040654804142028192_",
    gradientUnits: "userSpaceOnUse",
    x1: 209.9137,
    y1: 135.8716,
    x2: 220.9374,
    y2: 135.8716,
    gradientTransform: "matrix(1 0 0 -1 0 202)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D1B935"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C9AD2E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000127742134137208976560000007040654804142028192_)"
    },
    d: "M210.1,61.8l2.6,0c0,0,6.2-0.4,7.7,3.3 c1.2,2.9-0.3,5.4-0.3,5.4s0-1.8-1.4-3.1c-2.2-2.1-6.4-1.9-6.4-1.9h-2.5L210.1,61.8z"
  }), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "213.3,96.2 227.6,96.6 227,99.6 212.7,99.2  "
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "210.7,90.4 213.3,96.2 212.7,99.2 210.5,94.4  "
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "210.4,96.2 210.5,99.1 196.2,98.7 196.1,95.8  "
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "191,84.4 196.6,84.6 196.5,88.2 191.3,88  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000077292907554048802730000005846968162550387856_",
    gradientUnits: "userSpaceOnUse",
    x1: 212.1526,
    y1: 152.414,
    x2: 212.1526,
    y2: 105.3679,
    gradientTransform: "matrix(1 0 0 -1 0 202)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F5ED60"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F7EF74"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000077292907554048802730000005846968162550387856_)"
    },
    d: "M227.6,96.6l-14.3-0.4l-2.6-5.8l-0.3,5.7 l-14.3-0.4l0.5-11.2l-5.6-0.2l0.6-13.7l5.6,0.2l0.9-21.3l23.9,0.6l0.3,0.2c0.4,0.2,11,5.8,11,17c0,10.1-7.7,15.4-11.1,17.2 L227.6,96.6z M214.3,73c0,0,0.2,0,0.5,0c0.8,0,2.4-0.1,3.7-0.9c1.5-0.9,2.3-2.4,2.3-4.7c0-4.9-5.1-5.4-7.4-5.5 c-0.2,0-3.3-0.1-3.3-0.1l-0.5,11L214.3,73L214.3,73z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000100360679017185802680000004393303676233223810_",
    gradientUnits: "userSpaceOnUse",
    x1: 212.1881,
    y1: 150.7342,
    x2: 212.1881,
    y2: 107.0778,
    gradientTransform: "matrix(1 0 0 -1 0 202)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#68120C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D83020"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000100360679017185802680000004393303676233223810_)"
    },
    d: "M199.7,51.3l21.9,0.6 c0,0,10.1,5.3,10.1,15.5c0,11.6-11.5,16.5-11.5,16.5l4.9,11.1l-10.7-0.3l-5.1-11.1l-0.5,10.9l-11-0.3l0.5-11.2l-5.6-0.2l0.5-10.4 l5.6,0.2L199.7,51.3z M208,74.4l6.2,0.2c0,0,8.3,0.8,8.3-7.2c0-7.2-9.5-7.1-9.5-7.1l-4.4-0.1L208,74.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000132766359678781315260000015179612604299535006_",
    gradientUnits: "userSpaceOnUse",
    x1: 212.192,
    y1: 150.5497,
    x2: 212.192,
    y2: 107.2342,
    gradientTransform: "matrix(1 0 0 -1 0 202)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#771915"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EE3524"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000132766359678781315260000015179612604299535006_)"
    },
    d: "M214.5,94.5l-5-11l-0.3,0.1l-0.5,10.7 L198,94l0.5-11.2l-5.6-0.2l0.4-10.1l5.6,0.2l0.9-21.3l21.7,0.6c0.6,0.3,10,5.6,10,15.4c0,11.4-11.3,16.3-11.4,16.3l-0.2,0.1 l4.9,11L214.5,94.5z M207.8,74.6l6.3,0.2c0,0,0.2,0,0.7,0h0c1,0,2.9-0.1,4.6-1.1c2.1-1.2,3.2-3.3,3.2-6.3c0-7.2-9.2-7.3-9.6-7.3 l-4.6-0.1L207.8,74.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "A"
  }, _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "234.4,97.4 248.1,100.9 246.5,103.8 233,100.4  "
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "250.5,97.5 248.8,100 250,107.2 251.7,104.2  "
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "254.7,106 256.4,103 270.4,106.6 267.9,109.3  "
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "256.1,99.2 256.4,103 254.7,106 254.6,101.5 250,107.2 251.7,104.2  "
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "256.7,84.7 257.1,90.4 255.3,89.9 255.1,87.2  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000023267057450402090490000010538903610020121503_",
    gradientUnits: "userSpaceOnUse",
    x1: 260.9213,
    y1: 148.3284,
    x2: 251.9967,
    y2: 97.7142,
    gradientTransform: "matrix(1 0 0 -1 0 202)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F5ED60"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F7EF74"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000023267057450402090490000010538903610020121503_)"
    },
    d: "M270.4,106.6l-14.1-3.6l-0.2-3.9 l-4.5,5.1l-1.2-6.8l-2.3,3.4l-13.8-3.5l30.1-43.1L270.4,106.6z M253.6,89.5l3.6,0.9l-0.4-5.7L253.6,89.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000177461872623236433840000003209267520244072324_",
    gradientUnits: "userSpaceOnUse",
    x1: 260.2344,
    y1: 143.7601,
    x2: 252.582,
    y2: 100.3614,
    gradientTransform: "matrix(1 0 0 -1 0 202)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#68120C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D83020"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000177461872623236433840000003209267520244072324_)"
    },
    d: "M237.1,96.4l26.2-37.6l5.2,45.7 l-10.6-2.7l-0.4-6.7l-4.9,5.5l-1.3-7.4l-3.9,5.8L237.1,96.4z M258.9,92.5l-0.9-12.8l-7.1,10.8L258.9,92.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000049943121358181801100000000336932414440825494_",
    gradientUnits: "userSpaceOnUse",
    x1: 260.1653,
    y1: 143.3002,
    x2: 252.6254,
    y2: 100.5394,
    gradientTransform: "matrix(1 0 0 -1 0 202)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#771915"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EE3524"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000049943121358181801100000000336932414440825494_)"
    },
    d: "M258.1,101.6l-0.4-6.9l-4.9,5.6 l-1.3-7.5l-4.1,6.1l-10-2.6l25.9-37l5.1,45L258.1,101.6z M250.7,90.6l8.4,2.2l-0.9-13.5L250.7,90.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "M"
  }, _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "319.4,125.8 315.4,128.1 302.8,122.8 306.7,120.4  "
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "306.2,111.3 310.3,108.1 306.7,120.4 302.8,122.8  "
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "294.1,120.7 297.5,118.2 295,101.5 292.2,107.5  "
  })), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "289.5,113.2 286.1,115.6 273.6,110.5 276.4,107.7  "
  })), _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "297.6,66.9 300.4,64.1 276.4,107.7 273.6,110.5  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000105412938607893910180000008676949722519826062_",
    gradientUnits: "userSpaceOnUse",
    x1: 315.0975,
    y1: 132.5536,
    x2: 297.3617,
    y2: 83.8249,
    gradientTransform: "matrix(1 0 0 -1 0 202)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F5ED60"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F7EF74"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000105412938607893910180000008676949722519826062_)"
    },
    points: "295,101.5 289.5,113.2  276.4,107.7 300.4,64.1 306.2,95.6 331.6,77.3 319.4,125.8 306.7,120.4 310.3,108.1 297.5,118.2  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000176751253362766139120000016779272671512895905_",
    gradientUnits: "userSpaceOnUse",
    x1: 313.3069,
    y1: 128.039,
    x2: 297.9373,
    y2: 85.8111,
    gradientTransform: "matrix(1 0 0 -1 0 202)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#68120C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D83020"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000176751253362766139120000016779272671512895905_)"
    },
    points: "288.5,111 278.5,106.8  299.4,68.9 304.9,98.4 328.7,81.3 318.1,123.5 308.5,119.5 313.2,103.7 298.5,115.2 295.7,96  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000038381991010422989880000010213699769631611318_",
    gradientUnits: "userSpaceOnUse",
    x1: 313.1966,
    y1: 127.5841,
    x2: 298.0516,
    y2: 85.9735,
    gradientTransform: "matrix(1 0 0 -1 0 202)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#771915"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EE3524"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000038381991010422989880000010213699769631611318_)"
    },
    points: "308.7,119.4 313.5,103.2  298.7,114.9 295.8,95.4 288.5,110.8 278.8,106.8 299.4,69.4 304.8,98.7 328.5,81.7 318,123.3  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "A_1_"
  }, _polygon28 || (_polygon28 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "323.1,129.4 318.9,131.6 356.9,98 361.5,95.5  "
  })), _polygon29 || (_polygon29 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "335,136.8 323.1,129.4 318.9,131.6 330.4,138.8  "
  })), _polygon30 || (_polygon30 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "338,134 337.7,140.8 333.1,142.8 333.2,137.6 335,136.8  "
  })), _polygon31 || (_polygon31 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "342.9,137.2 342.2,141.3 337.6,143.3 337.7,140.8  "
  })), _polygon32 || (_polygon32 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "349.1,150.4 337.6,143.3 342.2,141.3 353.9,148.6  "
  })), _polygon33 || (_polygon33 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "342.8,127.1 346.9,123.2 345.9,129.1  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000141424840237577215450000010975286394001612985_",
    gradientUnits: "userSpaceOnUse",
    x1: 363.0768,
    y1: 105.5574,
    x2: 337.5094,
    y2: 61.2734,
    gradientTransform: "matrix(1 0 0 -1 0 202)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F5ED60"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F7EF74"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000141424840237577215450000010975286394001612985_)"
    },
    d: "M353.9,148.6l-11.7-7.3l0.7-4.1l-5.2,3.6 l0.3-6.9l-3,2.9l-11.9-7.5l38.4-33.8L353.9,148.6z M342.8,127.1l3.1,1.9l1.1-5.8L342.8,127.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000163038176916501230260000003711926456456557975_",
    gradientUnits: "userSpaceOnUse",
    x1: 360.6259,
    y1: 101.5143,
    x2: 338.9701,
    y2: 64.0053,
    gradientTransform: "matrix(1 0 0 -1 0 202)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#68120C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D83020"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000163038176916501230260000003711926456456557975_)"
    },
    d: "M325.8,129.1l33.5-29.4l-6.6,46.2 l-8.7-5.4l1.1-6.8l-5.6,3.9l0.3-7.7l-5,4.8L325.8,129.1z M347.1,131.7l2.4-13.2l-9.3,8.9L347.1,131.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000134225602570211742230000013948297194569065404_",
    gradientUnits: "userSpaceOnUse",
    x1: 360.379,
    y1: 101.1071,
    x2: 339.0479,
    y2: 64.1605,
    gradientTransform: "matrix(1 0 0 -1 0 202)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#771915"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EE3524"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000134225602570211742230000013948297194569065404_)"
    },
    d: "M344.2,140.4l1.2-7.1l-5.7,3.9l0.3-7.7 l-5.2,5l-8.7-5.4l32.9-29l-6.5,45.5L344.2,140.4z M339.9,127.4l7.3,4.6l2.5-13.9L339.9,127.4z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFuturama);
export default __webpack_public_path__ + "static/media/futurama.c7cccb76d34b53eb2dd52d2dc902f490.svg";
export { ForwardRef as ReactComponent };